import React, { Fragment, memo, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import ReEnterPassword from './ReEnterPassword';
import { usePracticeList } from '../../hooks/useApi';
import { usePracticeProviderContext } from '../../context/PracticeProviderContext';
import useToggle from '../../hooks/useToggle';

function PracticeInfo() {
  const { practice: currentPracticeId } = usePracticeProviderContext();
  const { data = [] } = usePracticeList();
  const [reEnterPassword, toggleReEnterPassword] = useToggle(false);
  const [newPracticeId, setNewPracticeId] = useState(null);

  return (
    <Fragment>
      <Form>
        <Form.Group>
          {data &&
            data.map(({ id, name }) => (
              <Alert key={id} variant={'primary'}>
                <Form.Check
                  type={'checkbox'}
                  id={id}
                  label={name}
                  checked={currentPracticeId === id}
                  readOnly={currentPracticeId === id}
                  onChange={() => {
                    if (currentPracticeId !== id) {
                      setNewPracticeId(id);
                      toggleReEnterPassword();
                    }
                  }}
                />
              </Alert>
            ))}
        </Form.Group>
      </Form>
      <ReEnterPassword onClose={toggleReEnterPassword} show={reEnterPassword} newPracticeId={newPracticeId} />
    </Fragment>
  );
}

PracticeInfo.propTypes = {};
PracticeInfo.defaultProps = {};

export default memo(PracticeInfo);
